import titanWithoutDomainBR from './titanWithoutDomain.br';
import titanWithoutDomainCL from './titanWithoutDomain.cl';
import titanWithoutDomainCO from './titanWithoutDomain.co';
import titanWithoutDomainMX from './titanWithoutDomain.mx';

const titanWithoutDomain = {
  BR: titanWithoutDomainBR,
  CL: titanWithoutDomainCL,
  CO: titanWithoutDomainCO,
  MX: titanWithoutDomainMX,
};

export default titanWithoutDomain;
